// This file was auto-generated by Fern from our API Definition.
export const ChannelSessionScope = {
    Thread: "thread",
    Message: "message",
};
